import BlogCollectionHero from "./BlogCollectionHero";

export default BlogCollectionHero;